import axios from "axios";
import config from "./config";

const TOKEN_KEY = "momseduc_token";
const REFRESH_TOKEN_KEY = "momseduc_refresh_token";

export const apiClient = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// ── Request interceptor : attach Bearer token ──────────────────────────────
apiClient.interceptors.request.use((reqConfig) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token && reqConfig.headers) {
    reqConfig.headers.Authorization = `Bearer ${token}`;
  }
  return reqConfig;
});

// ── Response interceptor : handle 401 / token refresh ─────────────────────
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
        const { data } = await axios.post(
          `${config.apiBaseUrl}/token/refresh`,
          {
            refresh_token: refreshToken,
          },
        );

        localStorage.setItem(TOKEN_KEY, data.token);
        localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token);

        originalRequest.headers.Authorization = `Bearer ${data.token}`;
        return apiClient(originalRequest);
      } catch {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export { TOKEN_KEY, REFRESH_TOKEN_KEY };
export default apiClient;
